<template>
  <div v-if="canPokerAct || showPokerPassoHint" class="panoramica-actions">
    <template v-if="canPokerAct">
      <v-btn
        v-if="migliore_offerta.vincitore"
        rounded
        color="primary"
        @click="setRilancio(1)"
      >
        +1
      </v-btn>
      <v-btn
        v-if="migliore_offerta.vincitore && maxRilancio > 1"
        rounded
        color="primary"
        @click="setRilancio(maxRilancio)"
      >
        +{{ maxRilancio }}
      </v-btn>
      <v-btn
        v-if="!migliore_offerta.vincitore"
        rounded
        color="primary"
        @click="setOffertaCustom(minOfferta)"
      >
        {{ minOfferta }}
      </v-btn>
      <v-btn
        v-show="maxOfferta > 1"
        rounded
        color="primary"
        @click="showNumpad"
      >
        ...
      </v-btn>
      <v-btn rounded color="white" class="text--text" @click="setPasso">
        Passo
      </v-btn>
    </template>
    <div v-else class="panoramica-poker-hint">
      {{ pokerPassoText }}
    </div>
  </div>
</template>

<script>
import mixins from "../../js/mixins";
import astaPokerActionsMixin from "../../js/mixins/astaPokerActionsMixin";

export default {
  name: "asta-poker-header-actions",
  mixins: [mixins, astaPokerActionsMixin],
};
</script>

<style lang="scss" scoped>
.panoramica-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.panoramica-poker-hint {
  font-size: 11px;
  line-height: 1.2;
  color: #fff;
}
</style>
